export const SERVER_UNAVAILABLE_ERROR = 'SERVER_UNAVAILABLE_ERROR'
